// KDANKGM05010_契約書内容確認画面
import React from 'react';
import Heading from '../../molecules/Heading';
import { GuarantorInfo } from '../../types/Template';
import { status_code_list as status } from '../../Const';

interface Props {
  status_code: Number;
  guarantor_info: GuarantorInfo;
  is_signed: boolean;
}

const ContractContentConfirmHeadingArea: React.FC<Props> = ({
  status_code,
  guarantor_info,
  is_signed
}) => {
  /**
   * 
   * @returns ガイドテキストの文字列を出力する
   * @returns string ガイドテキストの文字列
   */
  const guideText = () => {
    switch (status_code) {
      case status.contract_document_register1:
      case status.contract_document_register2:
        return '契約書の確認を行い、「契約手続きに進む」をクリックして下さい。';
      case status.contract_conclusion:
        if ((guarantor_info.is_guarantor && guarantor_info.is_signed) || (!guarantor_info.is_guarantor && is_signed)) {
          // 契約締結中かつ、ユーザが署名済みの場合
          return '契約の署名、手続きの進行待ちです。';
        }
        return '契約書の確認を行い、「契約手続きに進む」をクリックして下さい。';
      case status.contract_conclusion_wait:
        return '契約の署名、手続きの進行待ちです。';
      case status.contract_withdrawal_wait:
        return 'いずれかの契約者の方が契約を辞退しています。契約手続きは進められません。';
    }
  };

  return (
    <>
      <Heading size="m" label="電子契約書確認" />
      <p>{guideText()}</p>
    </>
  );
};

export default ContractContentConfirmHeadingArea;
